// has-input-changed.util.ts
import { SimpleChange, SimpleChanges } from "@angular/core";
import { isEqual } from "lodash-es";

export type InputChangeOptions = {
  ignoreFirstChange?: boolean;
};

/**
 * Retorna true se o Input `key` sofreu alteração em ngOnChanges.
 * Usa lodash isEqual por padrão para comparar previousValue vs currentValue.
 */
export function hasInputChanged<
  T extends object,
  K extends Extract<keyof T, string>,
>(changes: SimpleChanges, key: K, options: InputChangeOptions = {}): boolean {
  const change = changes[key as string] as SimpleChange | undefined;
  if (!change) return false;

  if (options.ignoreFirstChange && change.firstChange) return false;

  const equal = isEqual(
    change.previousValue as T[K],
    change.currentValue as T[K],
  );

  return !equal;
}

/** Retorna o SimpleChange tipado (ou undefined) para o Input `key`. */
export function getInputChange<
  T extends Record<string, unknown>,
  K extends keyof T,
>(changes: SimpleChanges, key: K): SimpleChange | undefined {
  return changes[key as string];
}
